module.exports = __webpack_public_path__ + "img/ssb_logo4.0c48fe58.png";